/*
 * Copyright (c) 2025 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Pair Icon component.
 */
export const PairIcon = React.memo((props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
      <path d="M5.95222 13.6685H3.5C3.22386 13.6685 3 13.4447 3 13.1685V5.5C3 5.22386 3.22386 5 3.5 5H14.5911C14.8672 5 15.0911 5.22386 15.0911 5.5V13.1685C15.0911 13.4447 14.8672 13.6685 14.5911 13.6685H10.2575" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
      <path d="M17.241 9.3418H19.7005C19.9766 9.3418 20.2005 9.56565 20.2005 9.8418V17.5103C20.2005 17.7865 19.9766 18.0103 19.7005 18.0103H8.60937C8.33323 18.0103 8.10938 17.7865 8.10938 17.5103V9.8418C8.10938 9.56566 8.33323 9.3418 8.60937 9.3418H12.9574" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
    </svg>
  );
});
